import { render, staticRenderFns } from "./ed-homework-viewer.vue?vue&type=template&id=131e152e&scoped=true&"
import script from "./ed-homework-viewer.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-viewer.scss?vue&type=style&index=0&id=131e152e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e152e",
  null
  
)

export default component.exports